"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNavigationParams = getNavigationParams;
exports.getTypeFiles = getTypeFiles;
function getNavigationParams(_ref) {
  var portalConfig = _ref.portalConfig,
    groupId = _ref.groupId,
    assetId = _ref.assetId,
    version = _ref.version,
    versionGroup = _ref.versionGroup;
  var versionsNavigation = portalConfig.versionsNavigation;
  if (versionsNavigation === 'version-group') {
    return {
      groupId: groupId,
      assetId: assetId,
      versionGroup: versionGroup
    };
  }
  return {
    groupId: groupId,
    assetId: assetId,
    version: version
  };
}
function getTypeFiles(files, asset, studioMetadata, section, config) {
  var isStudio = !!(studioMetadata && studioMetadata.version);
  if (files && asset.files) {
    return files(asset, isStudio ? studioMetadata : null, section, config);
  }
  return {
    files: []
  };
}
//# sourceMappingURL=portals.js.map